/* tslint:disable */
/* eslint-disable */
/**
 * BonusX
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InputSendMessageToServiceRequest } from '../models';
// @ts-ignore
import type { ServiceRequestMessage } from '../models';
/**
 * MessageApi - axios parameter creator
 * @export
 */
export const MessageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         *  **Permission required**: [\"readOne\", \"ServiceRequest\"] 
         * @summary Get message for service request | Permission required: [\"readOne\", \"ServiceRequest\"]
         * @param {number} serviceRequestId 
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageForServiceRequest: async (serviceRequestId: number, filter?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceRequestId' is not null or undefined
            assertParamExists('getMessageForServiceRequest', 'serviceRequestId', serviceRequestId)
            const localVarPath = `/messages/{serviceRequestId}/`
                .replace(`{${"serviceRequestId"}}`, encodeURIComponent(String(serviceRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (filter !== undefined) {
                localVarQueryParameter['filter'] = filter;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"readOne\", \"ServiceRequest\"] 
         * @summary Message to see from service request | Permission required: [\"readOne\", \"ServiceRequest\"]
         * @param {number} serviceRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageToSeeFromServiceRequest: async (serviceRequestId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceRequestId' is not null or undefined
            assertParamExists('messageToSeeFromServiceRequest', 'serviceRequestId', serviceRequestId)
            const localVarPath = `/messages/{serviceRequestId}/seen`
                .replace(`{${"serviceRequestId"}}`, encodeURIComponent(String(serviceRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *  **Permission required**: [\"readOne\", \"ServiceRequest\"] 
         * @summary Read messages from service request | Permission required: [\"readOne\", \"ServiceRequest\"]
         * @param {number} serviceRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readMessagesFromServiceRequest: async (serviceRequestId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceRequestId' is not null or undefined
            assertParamExists('readMessagesFromServiceRequest', 'serviceRequestId', serviceRequestId)
            const localVarPath = `/messages/{serviceRequestId}/seen`
                .replace(`{${"serviceRequestId"}}`, encodeURIComponent(String(serviceRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Send message to service request
         * @param {number} serviceRequestId 
         * @param {InputSendMessageToServiceRequest} [inputSendMessageToServiceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessageToServiceRequest: async (serviceRequestId: number, inputSendMessageToServiceRequest?: InputSendMessageToServiceRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serviceRequestId' is not null or undefined
            assertParamExists('sendMessageToServiceRequest', 'serviceRequestId', serviceRequestId)
            const localVarPath = `/messages/{serviceRequestId}/`
                .replace(`{${"serviceRequestId"}}`, encodeURIComponent(String(serviceRequestId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication cookieAuth required

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(inputSendMessageToServiceRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MessageApi - functional programming interface
 * @export
 */
export const MessageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MessageApiAxiosParamCreator(configuration)
    return {
        /**
         *  **Permission required**: [\"readOne\", \"ServiceRequest\"] 
         * @summary Get message for service request | Permission required: [\"readOne\", \"ServiceRequest\"]
         * @param {number} serviceRequestId 
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMessageForServiceRequest(serviceRequestId: number, filter?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServiceRequestMessage>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMessageForServiceRequest(serviceRequestId, filter, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessageApi.getMessageForServiceRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"readOne\", \"ServiceRequest\"] 
         * @summary Message to see from service request | Permission required: [\"readOne\", \"ServiceRequest\"]
         * @param {number} serviceRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async messageToSeeFromServiceRequest(serviceRequestId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.messageToSeeFromServiceRequest(serviceRequestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessageApi.messageToSeeFromServiceRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *  **Permission required**: [\"readOne\", \"ServiceRequest\"] 
         * @summary Read messages from service request | Permission required: [\"readOne\", \"ServiceRequest\"]
         * @param {number} serviceRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async readMessagesFromServiceRequest(serviceRequestId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.readMessagesFromServiceRequest(serviceRequestId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessageApi.readMessagesFromServiceRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Send message to service request
         * @param {number} serviceRequestId 
         * @param {InputSendMessageToServiceRequest} [inputSendMessageToServiceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendMessageToServiceRequest(serviceRequestId: number, inputSendMessageToServiceRequest?: InputSendMessageToServiceRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServiceRequestMessage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendMessageToServiceRequest(serviceRequestId, inputSendMessageToServiceRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MessageApi.sendMessageToServiceRequest']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MessageApi - factory interface
 * @export
 */
export const MessageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MessageApiFp(configuration)
    return {
        /**
         *  **Permission required**: [\"readOne\", \"ServiceRequest\"] 
         * @summary Get message for service request | Permission required: [\"readOne\", \"ServiceRequest\"]
         * @param {number} serviceRequestId 
         * @param {string} [filter] page, perPage, order, orderBy, filter (object)
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMessageForServiceRequest(serviceRequestId: number, filter?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServiceRequestMessage>> {
            return localVarFp.getMessageForServiceRequest(serviceRequestId, filter, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"readOne\", \"ServiceRequest\"] 
         * @summary Message to see from service request | Permission required: [\"readOne\", \"ServiceRequest\"]
         * @param {number} serviceRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        messageToSeeFromServiceRequest(serviceRequestId: number, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.messageToSeeFromServiceRequest(serviceRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         *  **Permission required**: [\"readOne\", \"ServiceRequest\"] 
         * @summary Read messages from service request | Permission required: [\"readOne\", \"ServiceRequest\"]
         * @param {number} serviceRequestId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        readMessagesFromServiceRequest(serviceRequestId: number, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.readMessagesFromServiceRequest(serviceRequestId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Send message to service request
         * @param {number} serviceRequestId 
         * @param {InputSendMessageToServiceRequest} [inputSendMessageToServiceRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessageToServiceRequest(serviceRequestId: number, inputSendMessageToServiceRequest?: InputSendMessageToServiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServiceRequestMessage> {
            return localVarFp.sendMessageToServiceRequest(serviceRequestId, inputSendMessageToServiceRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MessageApi - interface
 * @export
 * @interface MessageApi
 */
export interface MessageApiInterface {
    /**
     *  **Permission required**: [\"readOne\", \"ServiceRequest\"] 
     * @summary Get message for service request | Permission required: [\"readOne\", \"ServiceRequest\"]
     * @param {number} serviceRequestId 
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApiInterface
     */
    getMessageForServiceRequest(serviceRequestId: number, filter?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServiceRequestMessage>>;

    /**
     *  **Permission required**: [\"readOne\", \"ServiceRequest\"] 
     * @summary Message to see from service request | Permission required: [\"readOne\", \"ServiceRequest\"]
     * @param {number} serviceRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApiInterface
     */
    messageToSeeFromServiceRequest(serviceRequestId: number, options?: RawAxiosRequestConfig): AxiosPromise<boolean>;

    /**
     *  **Permission required**: [\"readOne\", \"ServiceRequest\"] 
     * @summary Read messages from service request | Permission required: [\"readOne\", \"ServiceRequest\"]
     * @param {number} serviceRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApiInterface
     */
    readMessagesFromServiceRequest(serviceRequestId: number, options?: RawAxiosRequestConfig): AxiosPromise<boolean>;

    /**
     * 
     * @summary Send message to service request
     * @param {number} serviceRequestId 
     * @param {InputSendMessageToServiceRequest} [inputSendMessageToServiceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApiInterface
     */
    sendMessageToServiceRequest(serviceRequestId: number, inputSendMessageToServiceRequest?: InputSendMessageToServiceRequest, options?: RawAxiosRequestConfig): AxiosPromise<ServiceRequestMessage>;

}

/**
 * MessageApi - object-oriented interface
 * @export
 * @class MessageApi
 * @extends {BaseAPI}
 */
export class MessageApi extends BaseAPI implements MessageApiInterface {
    /**
     *  **Permission required**: [\"readOne\", \"ServiceRequest\"] 
     * @summary Get message for service request | Permission required: [\"readOne\", \"ServiceRequest\"]
     * @param {number} serviceRequestId 
     * @param {string} [filter] page, perPage, order, orderBy, filter (object)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public getMessageForServiceRequest(serviceRequestId: number, filter?: string, options?: RawAxiosRequestConfig) {
        return MessageApiFp(this.configuration).getMessageForServiceRequest(serviceRequestId, filter, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"readOne\", \"ServiceRequest\"] 
     * @summary Message to see from service request | Permission required: [\"readOne\", \"ServiceRequest\"]
     * @param {number} serviceRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public messageToSeeFromServiceRequest(serviceRequestId: number, options?: RawAxiosRequestConfig) {
        return MessageApiFp(this.configuration).messageToSeeFromServiceRequest(serviceRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     *  **Permission required**: [\"readOne\", \"ServiceRequest\"] 
     * @summary Read messages from service request | Permission required: [\"readOne\", \"ServiceRequest\"]
     * @param {number} serviceRequestId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public readMessagesFromServiceRequest(serviceRequestId: number, options?: RawAxiosRequestConfig) {
        return MessageApiFp(this.configuration).readMessagesFromServiceRequest(serviceRequestId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Send message to service request
     * @param {number} serviceRequestId 
     * @param {InputSendMessageToServiceRequest} [inputSendMessageToServiceRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MessageApi
     */
    public sendMessageToServiceRequest(serviceRequestId: number, inputSendMessageToServiceRequest?: InputSendMessageToServiceRequest, options?: RawAxiosRequestConfig) {
        return MessageApiFp(this.configuration).sendMessageToServiceRequest(serviceRequestId, inputSendMessageToServiceRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

